import { Button } from "@/components/ui/button";

/**
 * "Couldn't load your account" + Retry — shown when the identity (boot)
 * lookup failed. Never guess a destination or render the app on a failed
 * identity: staff, managers, accountants and location iPads land on very
 * different pages.
 */
export function IdentityErrorRetry({ onRetry }: { onRetry: () => void }): JSX.Element {
  return (
    <div className="p-6 max-w-md mx-auto text-center space-y-3">
      <p className="text-base font-medium text-foreground">
        Couldn't load your account.
      </p>
      <p className="text-sm text-muted-foreground">
        Something went wrong looking up your staff record. Try again.
      </p>
      <Button variant="outline" size="sm" onClick={onRetry}>
        Retry
      </Button>
    </div>
  );
}
